import React, { FC, MutableRefObject, useEffect, useRef } from 'react';
import { Input, InputWrapper /* Placeholder */ } from './InputFieldWithPlaceholder.css';

type PropTypes = {
    id?: string;
    defaultValue: string;
    type: 'text' | 'password';
    placeholder: string;
    onChange: () => void;
    onKeyUp: (e) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    inputRef: MutableRefObject<HTMLInputElement>;
    tabindex?: number;
    role?: string;
    autoComplete?: string;
};

export const InputFieldWithPlaceholder: FC<PropTypes> = ({
    defaultValue = '',
    type,
    placeholder,
    onChange,
    onKeyUp,
    onFocus = () => {},
    onBlur = () => {},
    inputRef,
    id,
    tabindex,
    role,
    autoComplete,
    ...rest
}) => {
    const inputReference = useRef<HTMLInputElement>(null);

    const onInputChange = () => {
        onChange();
    };

    useEffect(() => {
        inputRef.current = inputReference.current;
    }, [inputReference.current]);

    return (
        <InputWrapper {...rest}>
            <Input
                id={id}
                defaultValue={defaultValue}
                type={type}
                autoComplete={autoComplete}
                placeholder={placeholder}
                onKeyUp={onKeyUp}
                onChange={onInputChange}
                onFocus={onFocus}
                onBlur={onBlur}
                ref={inputReference}
                tabIndex={tabindex}
                role={role}
            />
        </InputWrapper>
    );
};
